import AdminApiService from "src/api/AdminApiService";
import { useQuery } from "@tanstack/react-query";
import { queryOptions } from "./v4QueryOptions/queryOptions";

//This only gets the string names. It will be deprecated soon
export const getAllAzureIoTEdgeDevicesQueryOptions = queryOptions({
        queryKey: ["getAllAzureIoTEdgeDevices"],
        queryFn: async (q) => {
            return await AdminApiService.getAllAzureIoTEdgeDevices(q.signal);
        }
    });
